import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Gift } from 'src/app/gift/gift';
import { SendGiftDialogComponent } from 'src/app/gift/send-gift-dialog/send-gift-dialog.component';
import { Theme } from 'src/app/theme/theme';
import { UserInfo } from 'src/app/user-info';
import { UserService } from '../user.service';

@Component({
  selector: 'app-user-gifts',
  templateUrl: './user-gifts.component.html',
  styleUrls: ['./user-gifts.component.scss'],
  standalone: false
})
export class UserGiftsComponent implements OnChanges {
  private userService = inject(UserService);
  private dialog = inject(MatDialog);

  @Input()
  userInfo: UserInfo;

  @Input()
  theme: Theme;

  userGifts: Gift[] = [];
  isLoading = false;

  ngOnChanges(changes: SimpleChanges): void {
    this.userGifts = [];
    this.loadGifts();
  }

  loadGifts() {
    this.isLoading = true;
    this.userService.getGifts(this.userInfo.username).subscribe({
      next: (gifts) => {
        this.userGifts = gifts;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  get isSelf(): boolean {
    return this.userInfo.username === this.userService.userInfo.username;
  }

  get isTribeSelected(): boolean {
    if (!this.userInfo.character || !this.userInfo.character.tribe) {
      return false;
    }
    return true;
  }

  sendGift(): void {
    const dialogRef = this.dialog.open(SendGiftDialogComponent, {
      panelClass: 'send-gift-dialog',
      data: {
        theme: this.theme,
        userInfo: this.userInfo
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadGifts();
      }
    });
  }
}
